export default __webpack_public_path__ + "static/media/29.64358419.mp3";